import { APICore } from "./apiCore";

const api = new APICore();

// Get all offers
function getOffersApi() {
  const baseUrl = "/offers";
  return api.get(`${baseUrl}`, {});
}

// Update an offer
function updateOfferApi(params: {
  id: string;
  description: string;
  order?: number;
  status?: string;
}) {
  const baseUrl = "/offers";
  return api.updatePatch(`${baseUrl}/${params.id}`, params);
}

// Add a new offer
function addOfferApi(params: {
  description: string;
  order?: number;
  status?: string;
}) {
  const baseUrl = "/offers";
  return api.create(`${baseUrl}`, params);
}

// Delete an offer
function deleteOfferApi(params: { id: string }) {
  const baseUrl = "/offers";
  return api.delete(`${baseUrl}/${params.id}`);
}

export { getOffersApi, updateOfferApi, addOfferApi, deleteOfferApi };
